import React from 'react'
import './PageHeadline.css'

const PageHeadline = ({children}) => {
    return (
        <div className="page-headline">
            <div className="overlay" style={{backgroundImage: `url("../img/single.svg")`}}>
                <h2>{children}</h2>
            </div>
        </div>
    )
}

export default PageHeadline